





























import { getPublicHoliday } from '@/api/getPublicDay'
import { beforeCheckMedicalTreatmentSpot } from '@/api/treatment-before-check'
import { retrieveAllTreatmentCourseSpots, retrieveAllTreatmentSpots } from '@/api/treatment-spot'
import { MedicalTreatmentSpot } from '@/interface/api'
import { ReservationFormViewModel } from '@/models/ReservationFormViewModel'
import { formatDate, formatUuid } from '@/utils'
import Constants from '@/utils/constants'
import { Component, Prop, Vue } from 'vue-property-decorator'
import CalendarButton from '../atoms/CalendarButton.vue'
import ReservationCalendar from '../templates/ReservationCalendar.vue'
  
@Component({
    name: 'PopupCalendar',
    components: {
        ReservationCalendar,
        CalendarButton
    }
})
export default class PopupCalendar extends Vue {
@Prop({ default: () => null }) reservationForm!: ReservationFormViewModel
  // カレンダーpopupメニュー
  public menu = false
  public startDate = new Date()
  public publicHolidyList: string[] = []
  public medicalTreatmentSpots: MedicalTreatmentSpot[] = []

  created() {
    this.getPublicHolidayList()
  }

  public closeDateSelectMenu() {
    this.menu = false
    this.medicalTreatmentSpots = []
  }

  private async getPublicHolidayList() {
    this.publicHolidyList = await getPublicHoliday()
  }

  public async fetchTreatmentSpot(startDate: Date) {
    if (!startDate) {
      startDate = new Date()
    }
    const params = {
      reservation_spot_date: formatDate(
        startDate,
        Constants.DateFormat.YYYY_MM_DD_HYPHEN
      ),
      treatment_category_name: this.reservationForm.treatmentCategoryName,
      // TODO is_first_treatment: this.form.isFirstTreatment,
      is_first_treatment: 1
    }

    if (this.reservationForm.clinic.treatmentCourseId) {
      // コースIDあり
      this.medicalTreatmentSpots = await retrieveAllTreatmentCourseSpots(
        this.reservationForm.clinic.medicalBusinessId,
        formatUuid(this.reservationForm.clinic.clinicId),
        formatUuid(this.reservationForm.clinic.clinicalDepartmentId),
        formatUuid(this.reservationForm.clinic.treatmentCourseId),
        params
      )
    } else {
      // コースIDあり
      this.medicalTreatmentSpots = await retrieveAllTreatmentSpots(
        this.reservationForm.clinic.medicalBusinessId,
        formatUuid(this.reservationForm.clinic.clinicId),
        formatUuid(this.reservationForm.clinic.clinicalDepartmentId),
        params
      )
    }
  }

  public async setTreatmentSpot(spotId: string, spotDatetime: Date) {
    const checkresult = await this.beforeCheck(spotId, spotDatetime)

    if (!checkresult) {
        await this.fetchTreatmentSpot(new Date())
    } else {
        this.$emit('set-treatment-spot', spotId, spotDatetime)
        this.closeDateSelectMenu();
    }
  }

  private async beforeCheck(
    spotId: string,
    spotDatetime: Date
  ): Promise<boolean> {
    const res = await beforeCheckMedicalTreatmentSpot(
      this.reservationForm.clinic.medicalBusinessId,
      formatUuid(this.reservationForm.clinic.clinicId),
      formatUuid(spotId)
    )
    if (res.result) {
      return true
    }
    return false
  }
}
